import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listTaskType } from "../actions/taskTypeActions";

export default function TaskType() {
  const dispatch = useDispatch();

  const taskTypeList = useSelector(
    (state) => state.taskTypeList
  );
  const { taskTypes, loading, error } = taskTypeList;

  useEffect(() => {
    if (!taskTypes) {
      dispatch(listTaskType());
    } else if (taskTypes.length == 0) {
      dispatch(listTaskType());
    }
  }, [dispatch, taskTypes]);

  return (
    <>
      {loading ? (
        <option value="0" key="1">
          Loading...
        </option>
      ) : taskTypes ? (
        taskTypes.map((countf, index) => (
          <option key={index+1} value={countf.TimeF}>
            {countf.TimeN}
          </option>
        ))
      ) : (
        <option value="0" key="1">
          {error}
        </option>
      )}
    </>
  );
}
